import charge from './modules/charge'
import common from './modules/common'
import device from './modules/device'
import home from './modules/home'
import user from './modules/user'
import coupon from './modules/coupon'
import techMonitor from './modules/techMonitor'
import retainUsers from './modules/retainUsers'
import login from './modules/login'
import enterprise from './modules/enterprise'
import electronTicket from './modules/electronTicket'
import notion from './modules/notion'
import activity from './modules/activity'

export default {
  charge,
  common,
  device,
  home,
  user,
  coupon,
  techMonitor,
  retainUsers,
  login,
  enterprise,
  electronTicket,
  notion,
  activity
}
